import { PageState } from './page.types';

// PAGE
export function pageStateVM(): PageState {
    return {
        init: true,
        canEdit: true,
        uiMode: '',
    };
}
